module.exports = __webpack_public_path__ + "static/media/waves.123d99ac.svg";